class BrixSearchResult {
  static init(...parameters) {
    return new BrixSearchResult(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-search-result', BrixSearchResult.init);
}
